module.exports = __webpack_public_path__ + "static/volumeTest-1091fd06548c288c190925327a42d48c.png";